/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { useState } from "react";
import useAccountsStore from "@/stores/useAccountsStore";
import useUIStore from "@/stores/useUIStore";
import { useAccounts, useTitleMap, useTasklists } from "@/hooks";
import useLocalStorage from "@/hooks/useLocalStorage";
import LoadingPage from "../LoadingPage";
import { useAnalytics } from "@/hooks/useAnalytics";
import { useConfigSync } from "@/hooks/useConfig";

// Import our new modular components
import Header from "./Header";
import Sidebar from "./Sidebar";
import SidebarContent from "./SidebarContent";
import MainContent from "./MainContent";
import SidebarToggle from "./SidebarToggle";
import EmailConsentDialog from "./EmailConsentDialog";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";

type Layout = "list" | "grid" | "horizontal";

const TaskView = () => {
  const { data: accounts, isLoading: accountsLoading } = useAccounts();
  const [showSidebar, setShowSidebar] = useState(true);
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);

  const [hasBeenAskedForEmailConsent, setHasBeenAskedForEmailConsent] = useLocalStorage("hasBeenAskedForEmailConsent", false);
  const [showConsentModal, setShowConsentModal] = useState(false);

  const filters = useUIStore((state) => state.filters);
  const setFilter = useUIStore((state) => state.setFilter);

  useConfigSync(accounts);

  // Session-resume identify + self-healing alias handled internally by the hook
  useAnalytics(accounts);

  if (accountsLoading || !accounts) return <LoadingPage />;

  return (
    <div className="h-screen relative max-md:h-full">
      <SidebarToggle
        showSidebar={showSidebar}
        toggleSidebar={() => setShowSidebar(!showSidebar)}
      />

      <Header onOpenMobileSidebar={() => setShowMobileSidebar(true)} />

      <div className="flex h-[calc(100%-3.5rem)]">
        <Sidebar
          accounts={accounts}
          showSidebar={showSidebar}
        />

        <MainContent
          accounts={accounts}
          showSidebar={showSidebar}
        />
      </div>

      {/* Mobile-only drawer for the lists sidebar; opened from the header hamburger */}
      <Sheet open={showMobileSidebar} onOpenChange={setShowMobileSidebar}>
        <SheetContent side="left" className="w-4/5 max-w-[320px] p-0 pt-8 flex flex-col justify-between bg-muted dark:bg-background md:hidden">
          <SheetTitle className="sr-only">Task lists</SheetTitle>
          <SidebarContent accounts={accounts} />
        </SheetContent>
      </Sheet>
    </div>
  );
};

export default TaskView; 